import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-toolbar-stack',
    templateUrl: './toolbar-stack.component.html',
    styleUrls: ['./toolbar-stack.component.scss'],
    standalone: false
})
export class ToolbarStackComponent implements OnInit {
  @Input() bottomText = '';
  topText: string | number = '';

  @Input('topText')
  set topTextInput(topText: string | number) {
    if (typeof topText === 'number') {
      topText = this.decimalPipe.transform(topText) || 0;
    }
    this.topText = topText;
  }

  constructor(private decimalPipe: DecimalPipe) {}

  ngOnInit(): void {}
}
